export const en = {
   common: {
      location: "Location",
      select_location: "Select Location",
      no_location_found: "No Location Found",
      production_line: "Production Line",
      select_production_line: "Select Production Line",
      no_production_line_found: "No Production Line Found",
      denomination: "Denomination",
      select_denomination: "Select Denomination",
      no_denomination_found: "No Denomination Found",
      organization: "Organization",
      select_organization: "Select Organization",
      no_organization_found: "No Organization Found",
      account: "Account",
      select_account: "Select Account",
      no_account_found: "No Account Found",
      depositing_customer: "Depositing Customer",
      select_depositing_customer: "Select Depositing Customer",
      no_depositing_customer_found: "No Depositing Customer Found",
      select_product: "Select Product",
      no_product_found: "No Products Found",
      success: "Success",
      error: "Error",
      cancel: "Cancel",
      yes: "Yes",
      no: "No",
      noOptionsMessage: "No Options",
      save: "Save",
      edit: "Edit",
      confirm: "Confirm",
      add: "Add",
      complete: "Complete",
      rows_per_page: "rows per page",
      show_more: "Show more",
      show_less: "Show less",
      no_data_available: "No Data Available",
      deleted: "deleted",
      select_user: "Select User",
      no_user_found: "No User Found",
      saved: "Saved"
   },
   production: {
      production: "Production",
      reload: "Reload",
      reloadButtonToolTip: "Fetch New Data",
      wrap_bag: "Wrap/Bag",
      in_process_wrap: "In Process Wrap/Bag",
      completed_wrap: "Completed Wrap/Bag",
      audit: "Audit",
      in_process_audit: "In Process Audit",
      completed_audit: "Completed Audit",
      edited_completed_audit: "Edited Completed Audit",
      cancelled_audit: "Cancelled Audit",
      verification: "Verification",
      in_process_verification: "In Process Verification",
      completed_verification: "Completed Verification",
      numi: "NUMI",
      in_process_numi: "In Process NUMI",
      completed_numi: "Completed NUMI",
   },
   wrap_bag: {
      wrap_bag: "wrap/bag",
      user: "User",
      date: "Date",
      product: "Product",
      box_bags_$value: "Box/Bags | $ Value",
      control_id: "Control ID",
      product_types: "Product Types",
      starting_count: "Starting Count",
      finished_box_bags: "Finished # of Boxes/Bags",
      $value: "$ Value",
      completed: "Completed",
      select_control_id: "Select Control ID",
      select_product_type: "Select Product Type",
      no_product_type: "No Product Type Found",
      select_denomination_first: "Select denomination First",
      save: "Save",
      edit: "Edit",
      split: "Split",
      send_to_Audit: "Send to audit",
      delete: "Delete",
      print_control_tag: "Print Control Tag",
      finished_greater_than_starting: "Finished # of Box/Bags must be greater than Starting count",
      value_exceed_10_percent: "The value should not be greater than +10% of the source value",
      count_present_in_control_id: "Count present in Control ID",
      units_present_in_control_id: "Units present in Control ID",
      unit_present_in_control_id: "Unit present in Control ID",
      user_count: "User Count",
      count: "Count",
      updated: "updated",
      complete_session: "Complete Session",
      release_order: "Release Order",
      reset: "Reset",
      end_of_day: "End of Day",
      end_of_day_sucessfully: "End of Day successfully",
      end_of_day_message: "Are you sure you want to end the day?",
      add_product: "Add Product",
      total_box_bag_value: "Total Box/Bag Value",
      total_converted_unit: "Total Converted Units",
      total_changeovers: "Total # of Changeovers",
      over_short_value: "Over / Short $ Value",
      wrap_control_id: "Wrap Control ID",
      delete_row: "Delete Row",
      delete_row_confirmation: "Are you sure you want to Delete row ?",
      wrapping_session_completed: "Wrapping session is completed successfully",
      total_changeovers_saved: "Total # of ChangeOvers saved successfully",
      total_good_mixed_saved: "Total Good Mixed Product Value Saved successfully",
      total_us_coin_bent_weight_saved: "Total US Coins Bent Weight Saved successfully",
      saved_succesfully: "Saved successfully",
      control_id_completed_succesfully: "Control ID Completed successfully",
      control_id_split_succesfully: "Control ID Split successfully",
      row_deleted_succesfully: "Row deleted successfully",
      process_with_exceed_value: "Proceed with Exceeding Source Value",
      process_with_exceed_value_message: "Are you sure you want to continue with more than +10% of the source value?",
      control_id_wrapping: "Control ID Wrapping",
      force_end_of_day: "Force End of Day",
      force_end_of_day_message: "Are you sure you want to force end the day?",
      force_end_of_day_sucessfully: "Force End of Day successfully",
      mixed_scan_error: "Mixed denomination Control ID wrapping is not allowed",
      user_production_count_delete: "delete count",
      delete_user_count: "delete user count",
      delete_user_count_message: "Are you sure you want to delete {{user}}'s count?",

      //in_Process_wrap / Completed
      total: "Total",
      employee: "Employee",
      org_acc: "Org | Acc",
      stc_value: "STC Value",
      actions: "Actions",
      edit_in_process_wrap_bag: "Edit In Process Wrap/Bag",
      view_completed_wrap_bag: "View Completed Wrap",
      wrapping: "Wrapping",
      edit_wrap_bag: "Edit Wrap/Bag",
      delete_edit_in_process_wrap_bag: "Delete In Process Wrap/Bag",
      delete_in_process_wrap_bag: "Delete In Process Wrap/Bag",
      delete_in_process_wrap_bag_message: "Are you sure you want to delete in process wrap/bag?",
      delete_in_process_wrap_bag_successfully: "In Process Wrap/Bag deleted successfully!",
      max_wrap_value_exceed: "Wrap/bag amount exceeds maximum ($200,000.00)",

      // reset: "Reset",
      control_id_found_succesfully: "Control ID {{controlID}} found successfully",
      wrap_value_on_save_complete_message_warning: "Wrapped value is lower than expected. <0/>Are you sure you want to <1>{{action}}</1> Wrap?",
      wrap_value_on_save_complete_second_message: "Are you sure you want to  <0>{{action}}</0> control ID <0>{{controlID}}</0> wrapping?",
   },
   audit: {
      serach_control_id: "Search Control ID",
      control_id_required: "Control ID is required",
      stc: "STC",
      control_ids: "Control ID(S)",
      required_reconcilliation: "Requires Reconciliations",
      pallet_tare_weight: "Pallet Tare Weight",
      pallet_weight: "Pallet Weight",
      production_emp_name: "Production Employee Name",
      notes: "Notes",
      collected_foreign_weight: "Collected Foreign Weight",
      foreign_weight: "Foreign Weight",
      email: "Email",
      print: "Print",
      complete: "Complete",
      audit_confirmation_messsage: "Are you sure you want to  <0>{{action}}</0> audit?",
      us_coin_bent_mute_weight: "US Coin Bent/Mute Weight",
      bent_weight: "Bent Weight",
      total_bent_weight: "Total Bent Weight",
      good_mixed_product: "Good Mixed Product",
      product_required: "Product is Required",
      invalid_value: "invalid Value",
      total_good_mixed: "Total Good Mixed",
      total_over_short: "Total Over/Short",
      delete_good_mixed_warning_warning: "Are you sure you want to delete good mixed product",
      delete_good_mixed_title: "Delete Good Mixed Product",
      remove_product: "Remove Product",
      audit_delete_sucessfully: "Audit deleted successfully!",
      cancel_audit: "Cancel Audit",
      view_cancel_audit: "View Cancelled Audit",
      edit_in_process_audit: "Edit In Process Audit",
      edit_completed_audit: "Edit Completed Audit",
      delete_audit: "Delete Audit",
      audit_delete_confirmation_message: "Are you sure you want to delete audit?",
      audit_save_complete_succesfully: "Audit {{action}} successfully!",
      saved: "Saved",
      completed: "Completed",
      edit_history: "Edit History",
      edit_time: "Edit Time",
      performed_by: "Performed By",
      field_change: "Field Change",
      inital_value: "Initial Value",
      changed_vlaue: "Changed Value",
      difference: "Difference",
      intial_weight: "Initial Weight",
      change_Weight: "Change Weight",
      weight_diffrence: "Weight Difference",
      audit_save_complete_edit_title: "{{action}} Audit",
   },
   verification: {
      verification_session: "Verification Session",
      select_verification_session: "Select Verification Session",
      verification_session_save_comfirm_msg: "Verification session {{verificationSessionID}} {{confirmationMsg}} successfully!",
      date_required: "Date is required",
      billing_category: "Billing Category",
      no_billing_category_found: "No Billing Category Found",
      select_billing_category: "Select Billing Category",
      required_billing_category: "Billing Category is required",
      delete_row: "Delete Row",
      verification_delete_msg: "Are you sure you want to Delete row ?",
      verification_acknowledge: "All signed off counts are final and will form the basis of any invoice totals. It is the responsibility of the Customer to ensure these counts are correct.",
      loc_agent_sign: "Location Agent Signature",
      coinwrap_emp_sign: "Coinwrap Employee Signature",
      sign_isrequired: "Signature is required",
      session_id: "Session ID",
      processing_date: "Processing date",
      emp_name_required: "Employee name is required",
      loc_agent_name_required: "Location agent name is required",
      loc_agent_sign_required: "Location agent signature is required",
      loc_required: "Location is required",
      org_required: "Organization is required",
      verifiction_saveconfirm_msg: "Are you sure, you want to <0>{{confirmAction}}</0> Verification?",
      loc_agent_name: "Location Agent Name",
      coinwrap_emp_name: "Coinwrap Employee Name",
      edit_verification: "Edit Verification",
      delete_verification: "Delete Verification",
      verifiction_delete_msg: "Are you sure, you want to <0>{{action}}</0> The <1>{{deleteVerifictaionID}}</1> Verification?",
      verificataion_delete_sucessfully: "Verification Deleted Successfully",
   }
};
